var _a, _b;
import { NotificationStatus, NotificationTargetType } from '../graphql/generatedNotifications/api';
export var NOTIFICATION_STATUS_MAP = (_a = {},
    _a[NotificationStatus.CREATED] = 'Created',
    _a[NotificationStatus.FAILED_HYDRATE] = 'Failed Hydrate',
    _a[NotificationStatus.FAILED_SENDING] = 'Failed Sending',
    _a[NotificationStatus.MEDIUM_DISABLED] = 'Medium Disabled',
    _a[NotificationStatus.QUEUED] = 'Queued',
    _a[NotificationStatus.SENT] = 'Sent',
    _a);
export var NOTIFICATION_TYPE_MAP = (_b = {},
    _b[NotificationTargetType.USER] = 'User',
    _b[NotificationTargetType.LIST] = 'List',
    _b[NotificationTargetType.GROUP] = 'Group',
    _b);
//# sourceMappingURL=notification.js.map